import React, { useState } from 'react';
import * as loginService from '@/services/login-service';
import "react-datepicker/dist/react-datepicker.css";
import { toast } from 'react-toastify';
import StringComponent from "@/components/forms/string-component";
import { setToken } from "@/common/user-token";
import { useNavigate } from "react-router";
import { setRole } from "@/common/user-role";

const Login: React.FC = () => {

    const [ email, setEmail ] = useState<string>("");
    const [ password, setPassword ] = useState<string>("");

    const navigate = useNavigate();

    const login = async (event: React.FormEvent) => {
        event.preventDefault();

        const login = async () => {
            return await loginService.Login(email, password);
        }

        try {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const response: any = await toast.promise(
                login(),
                {
                    pending: "Logging in"
                }
            )

            if (response.status !== 400) {
                setToken(response);
                setRole(email === 'admin' ? 'admin' : 'user');
                
                navigate("/");
            } else {
                toast.error("Invalid credentials, please check and try again");
            }

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e: any) {
            if (e.status == 400) {
                toast.error("Invalid credentials, please check and try again");
            }
        }
    }

    return (
        <div className="w-11/12 lg:w-3/4 mx-auto">
                
            <form onSubmit={login}>
                <div>
                    <h1 className="text-4xl md:text-6xl font-thin text-center pb-1 pt-3">Login</h1>
                    <hr className="mx-auto my-3" />
                    <StringComponent
                        value={email}
                        purpose="Email Address"
                        newValue={(newValue: string | undefined) => setEmail(newValue ?? "")} 
                    />

                    <StringComponent
                        value={password}
                        purpose="Password"
                        type="password"
                        newValue={(newValue: string | undefined) => setPassword(newValue ?? "")} 
                    />

                </div>

                <div className="flex justify-end mx-4 mt-4">
                    <button
                        type="submit"
                        disabled={!email || !password}
                        className="px-3 py-1 mb-2 bg-green-500 hover:brightness-110 disabled:opacity-50" 
                        >Login
                    </button>
                </div>
            </form>
        </div>
    );
}

export default Login;